export default __webpack_public_path__ + "static/media/NativeSharing_Logo.c8e42551.svg";